import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';


/**
 * Текстария для ввода сообщения в чат,
 * в отдельную компоненту, никакой логики внутри,
 * вынесена исключительно ради удобства переиспользования
 */

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ChatMessageInput' },
  __name: 'ChatMessageInput',
  props: {
    modelValue: {},
    sending: { type: Boolean }
  },
  emits: ["update:modelValue", "send"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);

return (_ctx: any,_cache: any) => {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_s_input = _resolveComponent("s-input")!

  return (_openBlock(), _createBlock(_component_s_input, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    type: "textarea",
    class: "s-input",
    disable: _ctx.sending,
    placeholder: "Введите сообщение...",
    clearable: "",
    autogrow: "",
    outlined: "",
    dense: "",
    "hide-bottom-space": "",
    onKeyup: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('send')), ["ctrl"]), ["enter"]))
  }, {
    after: _withCtx(() => [
      _createVNode(_component_s_btn, {
        unelevated: "",
        title: "Ctrl + Enter",
        class: _normalizeClass(["cursor-pointer", { shaking: _ctx.sending }]),
        disabled: _ctx.sending,
        type: "icon",
        icon: "app:send",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('send')))
      }, null, 8, ["class", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue", "disable", "onUpdate:modelValue"]))
}
}

})